<template>
  <div class="x-tablelist-view" data-automation="keyList">
    <!-- 搜索行 -->
    <ux-searchOption :layout="layout" :data="filter" @back="back"></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :emptyText="$t('HT.nodata')"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      layout: [
        {
          type: 'button',
          text: '返回查询',
          // right: true,
          event: 'back'
        }
      ],
      columns: [
        // 表头数据
        {
          label: '账号',
          prop: 'account',
          tooltip: true
        },
        {
          label: '时间',
          prop: 'time',
          tooltip: true
        },
        {
          label: 'IMEI',
          prop: 'IMEI',
          tooltip: true
        },
        {
          label: '备注',
          prop: 'remark',
          tooltip: true
        },
        {
          label: '操作',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: ['恢复', '详情'],
                colors: ['#0087ff'],
                event: ['recovery', 'info']
              },
              on: {
                recovery: () => {
                  this.$uxModal.show({
                    title: '恢复定位点',
                    content: '确定将恢复本次删除的定位点？',
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                },
                info: () => {
                  this.info(params);
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getLogList(params) {
      this.$api.log.getLogList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 返回上一目录
     */
    back() {
      this.$router.replace('/driftPoint');
    },

    /**
     * 改变页码
     * @param {Number} page 页码
     */
    change() {
      this.filter.page = 1;
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getLogList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getLogList(this.filter);
    }
  }
};
</script>
